import { Box } from "@mui/material";
import React from "react";

const TextPlaceholder = ({ callback, large, small, medium, rows }) => {
	return (
		<>
			{rows ? (
				<Box
				sx={{ width: "100%", height: "100%", padding: 2 }}
				onClick={callback}
				data-template-item="true"
				data-text-placeholder="true">
					{Array.from({ length: rows }).map((_, index) => (
						<Box key={index} sx={{ width: ["90%", "80%", "40%", "70%", "60%"][index % 5], height: "10px", backgroundColor: "#e4e5e9", borderRadius: 2, marginBottom: 2 }}></Box>
					))}
				</Box>
			)
			:small ? (
				<Box onClick={callback} data-template-item="true" data-text-placeholder="true">
					<Box
						sx={{
							width: "90%",
							height: "10px",
							backgroundColor: "#e4e5e9",
							borderRadius: 2,
							marginBottom: 2,
						}}></Box>
					<Box
						sx={{
							width: "80%",
							height: "10px",
							backgroundColor: "#e4e5e9",
							borderRadius: 2,
							marginBottom: 2,
						}}></Box>
				</Box>
			) : (
				<Box
					sx={{ width: "100%", height: "100%", padding: 2 }}
					onClick={callback}
					data-template-item="true"
					data-text-placeholder="true">
					<Box
						sx={{
							width: "90%",
							height: "10px",
							backgroundColor: "#e4e5e9",
							borderRadius: 2,
							marginBottom: 2,
						}}></Box>
					<Box
						sx={{
							width: "80%",
							height: "10px",
							backgroundColor: "#e4e5e9",
							borderRadius: 2,
							marginBottom: 2,
						}}></Box>
					<Box
						sx={{
							width: "60%",
							height: "10px",
							backgroundColor: "#e4e5e9",
							borderRadius: 2,
							marginBottom: 2,
						}}></Box>
					{!medium && (
						<>
							<Box
								sx={{
									width: "40%",
									height: "10px",
									backgroundColor: "#e4e5e9",
									borderRadius: 2,
									marginBottom: 2,
								}}></Box>
							<Box
								sx={{
									width: "70%",
									height: "10px",
									backgroundColor: "#e4e5e9",
									borderRadius: 2,
									marginBottom: 2,
								}}></Box>
							<Box
								sx={{
									width: "80%",
									height: "10px",
									backgroundColor: "#e4e5e9",
									borderRadius: 2,
									marginBottom: 2,
								}}></Box>
						</>
					)}
					{large && (
						<>
							<Box
								sx={{
									width: "50%",
									height: "10px",
									backgroundColor: "#e4e5e9",
									borderRadius: 2,
									marginBottom: 2,
								}}></Box>
							<Box
								sx={{
									width: "90%",
									height: "10px",
									backgroundColor: "#e4e5e9",
									borderRadius: 2,
									marginBottom: 2,
								}}></Box>
							<Box
								sx={{
									width: "60%",
									height: "10px",
									backgroundColor: "#e4e5e9",
									borderRadius: 2,
									marginBottom: 2,
								}}></Box>
						</>
					)}
				</Box>
			)}
		</>
	);
};

export default TextPlaceholder;
